import { useToast } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { getLeadByExternalIdQueryKey } from '../../../../../../services/marketplace/generated/kubb/hooks/useGetLeadByExternalId';
import { usePostLeadByExternalIdMessages } from '../../../../../../services/marketplace/generated/kubb/hooks/usePostLeadByExternalIdMessages';
import { CreateContactMessage } from '../../../../../../services/marketplace/generated/kubb/models/CreateContactMessage';

export const useSendMessage = (externalId: string) => {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { mutateAsync } = usePostLeadByExternalIdMessages();

  return useCallback(
    async (data: CreateContactMessage) => {
      await mutateAsync({ externalId, data });
      try {
        await queryClient.invalidateQueries({
          queryKey: getLeadByExternalIdQueryKey({ externalId }),
        });
      } catch {
        toast({
          title: 'Something went wrong',
          description: 'Refresh to see your latest messages.',
          status: 'error',
          duration: 4000,
          isClosable: false,
          position: 'top',
        });
      }
    },
    [mutateAsync, queryClient, externalId, toast],
  );
};
